/**
 * AppToast — Lightweight global toast notification for mobile.web
 *
 * Usage:
 *   import { showToast } from '../utils/toast';
 *   showToast('Staff switched successfully', 'success');
 *   showToast('Something went wrong', 'error');
 *   showToast('Please note...', 'info');
 *   showToast('Careful!', 'warning');
 */

const TOAST_DURATION = 5000;
const CONTAINER_ID = "app-toast-container";

const THEME = {
    success: { bg: "#2e7d32", icon: "✓" },
    error: { bg: "#c62828", icon: "✕" },
    info: { bg: "#1565c0", icon: "ℹ" },
    warning: { bg: "#e65100", icon: "⚠" },
};

function getOrCreateContainer() {
    let container = document.getElementById(CONTAINER_ID);
    if (!container) {
        container = document.createElement("div");
        container.id = CONTAINER_ID;
        Object.assign(container.style, {
            position: "fixed",
            top: "16px",
            right: "16px",
            zIndex: "99999",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            pointerEvents: "none",
            maxWidth: "380px",
            width: "calc(100% - 32px)",
        });
        document.body.appendChild(container);
    }
    return container;
}

export function showToast(message, type = "info") {
    if (!message) return;
    const container = getOrCreateContainer();
    const theme = THEME[type] || THEME.info;

    const toast = document.createElement("div");
    Object.assign(toast.style, {
        background: theme.bg,
        color: "#fff",
        padding: "12px 16px",
        borderRadius: "10px",
        fontSize: "14px",
        lineHeight: "1.4",
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.25)",
        pointerEvents: "auto",
        cursor: "pointer",
        opacity: "0",
        transform: "translateX(40px)",
        transition: "opacity 0.3s, transform 0.3s",
        wordBreak: "break-word",
    });

    const icon = document.createElement("span");
    icon.textContent = theme.icon;
    Object.assign(icon.style, {
        fontWeight: "bold",
        fontSize: "16px",
        lineHeight: "1",
        flexShrink: "0",
        marginTop: "1px",
    });

    const text = document.createElement("span");
    text.textContent = message;
    text.style.flex = "1";

    toast.appendChild(icon);
    toast.appendChild(text);
    container.appendChild(toast);

    // Animate in
    requestAnimationFrame(() => {
        toast.style.opacity = "1";
        toast.style.transform = "translateX(0)";
    });

    const dismiss = () => {
        toast.style.opacity = "0";
        toast.style.transform = "translateX(40px)";
        setTimeout(() => {
            toast.remove();
        }, 300);
    };

    toast.addEventListener("click", dismiss);
    setTimeout(dismiss, TOAST_DURATION);
}
